// ========================================
// 🎯 ENVIRONMENT CONTROL
// ========================================
// To switch environments, simply comment/uncomment the lines below:

// FOR DEVELOPMENT - Uncomment this line and comment the production line
// const ENVIRONMENT = "development";

// FOR PRODUCTION - Uncomment this line and comment the development line
const ENVIRONMENT = "production";

// ========================================
// Environment-specific configurations
// ========================================

const configs = {
  development: {
    // API Configuration
    API_URL: "http://localhost:5000",

    // App Configuration
    CLINIC_NAME: "SATYA HEART CLINIC (DEV)",
    ENVIRONMENT: "development",

    // Debug Configuration
    DEBUG: true,
    LOG_LEVEL: "debug",
  },

  production: {
    // API Configuration - Use environment variable or fallback
    API_URL:
      process.env.REACT_APP_API_URL || "https://backend-satya.onrender.com",

    // App Configuration
    CLINIC_NAME: process.env.REACT_APP_CLINIC_NAME || "SATYA HEART CLINIC",
    ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT || "production",

    // Debug Configuration
    DEBUG: process.env.REACT_APP_DEBUG === "true" || false,
    LOG_LEVEL: process.env.REACT_APP_LOG_LEVEL || "error",
  },
};

// Get current configuration
const currentConfig = configs[ENVIRONMENT];

// Apply configuration to process.env
Object.keys(currentConfig).forEach((key) => {
  process.env[`REACT_APP_${key}`] = currentConfig[key];
});

console.log(`🎯 Frontend Environment: ${ENVIRONMENT.toUpperCase()}`);
console.log(`🌐 API URL: ${currentConfig.API_URL}`);
console.log(`🏥 Clinic: ${currentConfig.CLINIC_NAME}`);

module.exports = {
  ENVIRONMENT,
  config: currentConfig,
};
